<script setup lang="ts">
interface Props {
  loadingMessage?: string
  minimal?: boolean
}
defineProps<Props>()
</script>

<template>
  <PvProgressBar
    v-if="minimal"
    mode="indeterminate"
    class="my-[5px] md:my-[10px] p-1"
  />
  <CardComponent
    v-else
    class="w-full px-5 text-center"
    bg="light"
  >
    <PvProgressBar
      mode="indeterminate"
      class="my-[5px] md:my-[10px] h-[1rem] w-full"
    />
    <div
      v-if="loadingMessage"
      class="text-xs md:text-sm text-center"
    >
      {{ loadingMessage }}
    </div>
  </CardComponent>
</template>
